import { render, staticRenderFns } from "./RegisterResume.vue?vue&type=template&id=df89fdca&scoped=true&"
import script from "./RegisterResume.vue?vue&type=script&lang=js&"
export * from "./RegisterResume.vue?vue&type=script&lang=js&"
import style0 from "./RegisterResume.vue?vue&type=style&index=0&id=df89fdca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df89fdca",
  null
  
)

export default component.exports